import { render, staticRenderFns } from "./Opis.vue?vue&type=template&id=715dc13a&"
import script from "./Opis.vue?vue&type=script&lang=js&"
export * from "./Opis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports